import { AgentType } from "./contact.model";
import { ContactEventType } from "./contactHistory.model";
import { OperationType } from "../../common/models/organization.model";

export class SuretyBondModel {
    id: string;
    instrumentId: string;
    ownerName: string;
    ricsOwnerNumber: string;
    rbdmsOwnerNumber?: string;
    ownerType?: OperationType;
    amount: number;
    bondInstrumentType: string;
    expirationDate?: Date;
    guarantor?: string;
    maturityDate?: Date;
}


export class CertificateOfDepositModel {
    id: string;
    instrumentId: string;
    ownerName: string;
    ownerNumber: string;
    ownerType?: OperationType;
    amount: number;
    bankAddress: string;
    bankContactPhoneNumber: string;
    bankContactEmail: string;
    maturityDate: Date;
    instrumentTypeCode: string;
}

export class SurplusInsurerModel {
    id: string;
    ownerName: string;
    ownerNumber: string;
    insurer: string;
    insurerAgentName: string;
    insuranceAmount: number;
    effectiveDate: Date;
    expirationDate: Date;
}

export class RbdmsOwnersModel {
    id: string;     
    ownerName: string;
    ownerNumber: string;
    ownerAddress: string;
}

export class WellTransferListingModel {
    applicationNumber: string;
    apiNumber: string;
    leaseName: string;
    wellName: string;
    wellNumber: string;
    transferor: string;
    transferee: string;
    salesDate: Date;
    slant: string;
    transferApprovalDate: Date;
    disposition?: string;
    legacyTracking?: string;
    wellTypeDescription?: string;
}

export interface ContactHistoryModel {
    organizationName: string;
    ricsOrganizationId: string;
    legacyOwnerId?: string;
    contactId: string;
    contactName: string;
    isUser: boolean;
    isEnabled: boolean;
    eventType?: ContactEventType;
    eventDetails?: string;
    timestamp: Date;
}

export class ReportSearchCriteria {
    fromDate: Date | null;
    toDate: Date | null;
    dateFields: string[];
}
    
export class BondSearchCriteria extends ReportSearchCriteria {
    isActive: boolean;
}

export class ContactHistoryCriteria extends ReportSearchCriteria {
    organizationId: string;
    authorities?: AgentType[]
    events?: string[]
}

export class BondingReportSearchCriteria  {
    instrumentId?: string;
    organizationIds?: string[];
    typeCodes?: string[];
    wellIds?: string[];
    startDate?: Date;
    endDate?: Date;
    getReleased?: boolean;
}


export class LetterOfCreditModel {
    id: string;
    ownerName: string;
    ricsOwnerNumber: string;
    rbdmsOwnerNumber: string;
    ownerType?: OperationType;
    bankName: string;
    bankAddress: string;
    bankContactPhoneNumber: string;
    bankContactEmail: string;
    expirationDate: Date;
}

export class InsuranceSearchCriteria {
    expirationFromDate: Date;
    expirationToDate: Date;
    legacyOrganizationId: string;
}

export enum LogEventLevel {
    Verbose = "Verbose",
    Debug = "Debug",
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
    Fatal = "Fatal"
}

export interface LogSearchSpec {
    messageSearchString?: string;
    messageTemplateString?: string;
    exceptionString?: string;
    logEventLevel?: LogEventLevel;
    startDate?: Date;
    endDate?: Date;
}

export interface ApplicationLog {
    id: number;
    message: string;
    messageTemplate: string;
    level: LogEventLevel;
    timeStamp?: Date;
    exception: string;
    properties: string;
}

export interface ApplicationLogResult extends ApplicationLog {
    utcTimeStamp?: Date;
}

